<template>
    <div>
        <p>In deze stages zitten zometeen leerlingen zonder via dit label gekoppeld te zijn.</p>
        <design-2021-apprentice-data-table
            :items="tableData"
            :fields="studentFields">
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internship-floating-student-modal-table-component',
    props: ['dataIn'],
    data() {
        return {
            data: this.dataIn,
            studentFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'floaters',
                    label: this.$t('internship.students'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            if (this.loaded === false) {
                return [];
            } else {
                let internships = this.dataIn.map((internship) => {
                    return {
                        name: internship.name,
                        floaters: internship.floaters
                            .map((floater) => {
                                return floater.full_name;
                            })
                            .join(', '),
                    };
                });
                return internships;
            }
        },
    },
};
</script>

<style scoped></style>
